export default __webpack_public_path__ + "static/discord@2x-751eee03f75fcee5112366798aab672b.png";